<template>
    <div class="rule-wrapper wrapper">
        <div class="rule-inner">
            <div class="logo">
                <img src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1du7590crdaf15jp2g79j8nfd9.png" alt="">
            </div>
            <h3 class="title">
                <img src="http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm271b11reg1s9kldcln3r.png" alt="">
            </h3>
            <div class="rule-content">
                <div class="rule-item flex">
                    <h5>活动名称：</h5>
                    <p>暖心春节，“封”个红包给你——来封面写祝福赢现金红包</p>
                </div>
                <div class="rule-item flex">
                    <h5>活动时间：</h5>
                    <p>2020年1月21日——2020年1月30日</p>
                </div>
                <div class="rule-item">
                    <h5>活动规则：</h5>
                    <h6><span>1</span>红包抽取方式</h6>
                    <div class="info">
                        <p>(1)&nbsp;&nbsp;&nbsp;&nbsp;只有通过实名认证的微信登录封面新闻APP的用户方可参与抽取本次活动红包。</p>
                        <p>(2)&nbsp;&nbsp;&nbsp;&nbsp;封面新闻APP已登录用户，在活动H5页面内以带话题写新年祝福动态、转发（活动H5页面、个人参与活动获得红包的页面截图）到微信、微信朋友圈，均可获得1次抽取红包的资格。</p>
                        <p>(3)&nbsp;&nbsp;&nbsp;&nbsp;每个封面新闻APP已登录用户每天通过带话题写新年祝福动态和转发两种行为，可获得抽取红包资格；每个用户每天只能获得2次抽取红包资格。</p>
                        <p>(4)&nbsp;&nbsp;&nbsp;&nbsp;活动期间，每个账号只有一次绑定微信机会，且一个账号只能绑定一个微信号！</p>                   
                    </div>
                    <h6><span>2</span>红包派送方式</h6>
                    <div class="info">
                        <p>(1)&nbsp;&nbsp;&nbsp;&nbsp;本次活动红包分为现金红包和祝福红包两种，两种不同形式的红包采用随机赠送的方式进行。</p>
                        <p>(2)&nbsp;&nbsp;&nbsp;&nbsp;用户获得现金红包后，点击拆红包，封面传媒将会把现金红包对应的现金直接存到用户登录封面新闻APP使用的微信零钱中。</p>
                        <p>(3)&nbsp;&nbsp;&nbsp;&nbsp;本次活动的现金红包金额，由四川封面传媒有限责任公司（以下简称“封面传媒”）提供，用户无需承担任何费用。</p>                   
                    </div>
                </div>
                <div class="rule-item">
                    <h5>注意事项：</h5>
                    <div class="info">
                        <p>(1)&nbsp;&nbsp;&nbsp;&nbsp;如因微信账号非实名认证导致用户无法领取已获得的现金红包，在活动结束后，视为用户自动放弃活动红包金额。若用户有使用工具进行恶意抽取红包等违法违规行为，一经发现，封面传媒将取消其参与活动的资格，并停止派发已抽取的现金红包。</p>
                        <p>(2)&nbsp;&nbsp;&nbsp;&nbsp;本活动最终解释权归封面传媒所有！</p>                  
                    </div>
                </div>
            </div>
        </div>      
    </div>
</template>

<script>

import COVER from '@/utils/COVER'

import { mapState, mapActions } from 'vuex'

export default {
    name: 'rule',
    data() {
        return {

        }
    },
    computed: {
      ...mapState(['aid', 'isApp', 'isImmerse', 'shareData', 'userinfo', 'versionSize'])
    },
    mounted() {
        this.checkTimeAsync().then(()=>{
            this.share()
        })  
        this.setPageLoadingAsync(false)
        document.querySelector('.loading-wrap').style.display = 'none'
        COVER.track(this.aid, 'load', '规则详情页加载')     
    },
    methods: {
        ...mapActions([
            'checkCanGetHb',
            'checkTimeAsync',
            'setPageLoadingAsync'
        ]),
        share() {
            let _this = this        
            let ShareData = JSON.parse(JSON.stringify(this.shareData))
            ShareData.callback = function(ret) {
                if(!_this.isApp) {
                    COVER.track(_this.aid, 'share', '分享'); 
                    return
                }
                var data = typeof ret == "string".toLowerCase() ? JSON.parse(ret) : ret; 
                var origin = data.origin || '';
				if(origin != 'None' && !COVER.isEmpty(origin)){
					COVER.track(_this.aid, 'share', '分享链接到'+origin);  
				} else {
					COVER.track(_this.aid, 'share', '分享'); 
				}
                if((data.status == 'success' || data.status == '1') && _this.userinfo.user_id){
                    _this.checkCanGetHb(2).then(()=> {
                        COVER.track(_this.aid, 'load', '红包雨页面加载')	
                        _this.$router.push('/game?type=2')
                    })
                }           
            }
            if (!this.isImmerse) {
                COVER.share(ShareData)
            }
        }
    }
}
</script>

<style lang="less">
    .rule-wrapper {
        position: relative;
        background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm261jtb13ff1b8m1mrkett2q.jpg) repeat-y center bottom;
        background-size: 100% auto;
        min-height: 100vh;
        &::before, &::after {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            content: '';
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm261q7b108pn9do2r4h2p.jpg) no-repeat center bottom;
            background-size: 100% auto;
        }
        &:before {
            background: url(http://7xte9b.com2.z0.glb.qiniucdn.com/o_1dts8mm28k2417secqqu9vqd44o.jpg) no-repeat center top;
            background-size: 100% auto;
        }
        .title {
            padding-top: 1.062802rem;
        }
    }
    .rule-inner {
        position: relative;
        z-index: 1;
    }
    .rule-content {
        font-size: .304428rem;
        color: #f8d196;
        padding: 0 .982287rem;
    }
    .rule-item {
        line-height: 1.5;
        margin-bottom: .080515rem;
        &.flex {
            display: inline-flex;
            overflow: hidden;
            h5 {
                flex-shrink: 0; 
            }
            p {
                flex: 1;
            }
        }
        h5 {
            font-size: .304428rem;
        }
        h6 {
            font-size: .304428rem;
            padding-left: .563607rem;
            position: relative;
            font-weight: normal;
            margin: .064412rem 0;
            &::before,span {
                width: .37037rem;
                height: .37037rem;
                position: absolute;
                left: 0;
                top: 0.05rem;
            }
            &::before {
                content: '';
                font-size: 0;              
                border-radius: 50%;
                background-color: #f8d196;               
            } 
            span {
                font-size: .304428rem;
                line-height: .37037rem;
                color: #d6291b;
                text-align: center;          
            }
        }
        .info {
            line-height: 1.7;
            font-size: .257649rem;
            padding-left: .466989rem;
            text-align: justify;
        }
    }
</style>